module.exports = __webpack_public_path__ + "static/media/tarif-solo.654ada5b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tarif-solo.svg
// module id = 1511
// module chunks = 0